import { useCallback, useMemo, useRef, useState } from 'react';
import { TokenPayload } from '@recurly/recurly-js';

export class ThreeDFailure extends Error {}

export interface ThreeDSecureErrorData {
  data?: {
    errorData?: {
      threeDSecureActionTokenId?: string;
      publicData?: {
        threeDSecureActionTokenId?: string;
      };
    };
  };
}

export enum ThreeDActionType {
  ADD_PAYMENT = 'add_payment',
  UPDATE_PAYMENT = 'update_payment',
  PURCHASE = 'purchase',
}

type ThreeDActionContext = {
  token?: string;
  actionType?: ThreeDActionType;
  selectedBillingInfoId?: string;
};

export const useThreeDSecureFlow = () => {
  const [threeDActionContext, setThreeDActionContext] = useState<ThreeDActionContext>();
  const [threeDActionError, setThreeDActionError] = useState<Error>();

  // We hold any older payment information here when we need to do the extra hop for 3D secure token:
  const preThreeDConfirmationCardInformation = useRef<{
    token: TokenPayload;
    isBackupPaymentMethod?: boolean;
    isPrimaryPaymentMethod?: boolean;
  }>();

  const onThreeDActionError = useCallback(() => {
    // We clear the information we have stored for the 3D secure flow
    setThreeDActionContext(undefined);
    setThreeDActionError(new ThreeDFailure());
  }, []);

  return useMemo(
    () => ({
      threeDActionContext,
      setThreeDActionContext,
      threeDActionError,
      setThreeDActionError,
      preThreeDConfirmationCardInformation,
      onThreeDActionError,
    }),
    [
      threeDActionContext,
      setThreeDActionContext,
      threeDActionError,
      setThreeDActionError,
      preThreeDConfirmationCardInformation,
      onThreeDActionError,
    ]
  );
};

export type UseThreeDSecureFlow = ReturnType<typeof useThreeDSecureFlow>;
